<template>
  <div class="container-fluid" id="about">
        <div class="row about-content justify-content-center">
          <div class="col-sm-12 col-md-5 col-lg-5">
            <img class="img-fluid" src="../assets/images/image_circle_new.jpg" alt="">
            <!-- <img src="../assets/images/circle-orange.png"  alt=""> -->
          </div>
          <div class="col-sm-12 col-md-5 col-lg-5 align-self-center">
           
              <div class="col">
                 <h2 class="pb-4">About Fiscoin</h2>
                <p>
                  Fiscoin is a web and mobile application that interfaces micro entrepreneurs in need of business
                  lifeline support (loans and grant) in rescuing their businesses due to the Covid-19 pandemic
                </p>
                <p>
                  The solution is implemented with two pronged approach-Grants [Towards Micro-enterprise] and
                  loans [Towards value chain development]
                </p>
              </div>
            
          <div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

/*--------------------- ABOUT ------------------*/
.about-content{
  padding-top:8rem;
  padding-bottom: 100px;
}
#signUp h2{
  font-size:3em; 
  font-weight: 500; 
  color:#000;
}
.about-content h2{
        color:black;
        font-weight: 700;
        font-size: 4em;
}
.about-content p{
  color:rgb(255,128,57) !important;
  line-height: 1.8em;
}
    @media screen and (max-width:767px){
       .about-content h2{
         text-align: center;
       }
    }

</style>